import { i18n } from '@/plugins/i18n'
import { vuetify } from '@/plugins/vuetify'
import { getLanguageTranslations, getOverrides } from '@shared/translations';

const rtl = (lang) => {
    return lang === 'ar-EG' || lang === 'ar' || lang === 'ur' || false
}

const locale = (lang) => {
    if (lang === 'hi') return 'hi-u-nu-deva'
    if (lang === 'ar') return 'ar-u-nu-arabext'
    return lang
}

const fallback = (lang) => {
    let split = lang.split('-')
    if (split.length > 1) {
        return locale(split[0])
    }
    else {
        return lang
    }

}

export default {
    async load({ rootState }) {

        let translations = getLanguageTranslations();
        Object.entries(translations).map(translation => i18n.setLocaleMessage(locale(translation[0]), translation[1]));

        if (rootState.settings.code) {
            let overrides = getOverrides(rootState.settings.code);
            Object.entries(overrides).map(override => i18n.mergeLocaleMessage(locale(override[0]), override[1]));
        }
        
        return { ok: true };
    },


    async set({ state, commit, rootState, getters }, lang) {
        let set
        if(lang) {
            set = { selected: lang, source: 'user' }
        }
        else if (rootState.route.query.loginLang) {
            set = { selected: rootState.route.query.loginLang, source: 'user' }
        }
        else if (rootState.route.query.lang && rootState.route.query.forceLang) {
            set = { selected: rootState.route.query.lang, source: 'fallback' }
        }
        else if (state.source === 'user') {
            set = { selected: state.selected, source: 'user' }
        }
        else if (rootState.route.query.lang) {
            set = { selected: rootState.route.query.lang, source: 'query' }
        }
        else if (rootState.settings.languages) {
            let selected = rootState.settings.languages.find(x => x.default)
            set = { selected: selected.value, source: "config" }
        }
        else {
            set = {
                selected: 'en-US',
                source: 'fallback'
            }
        }

        if (!getters.all.some(x => x.value === set.selected)) {
            set = {
                selected: 'en-US',
                source: 'fallback'
            }
        }
        set.rtl = rtl(set.selected)
        commit('set', set)

        vuetify.framework.rtl = rtl(state.selected)
        i18n.locale = locale(state.selected)
        i18n.fallbackLocale = fallback(state.selected)
        vuetify.framework.lang.current = state.selected

        return { ok: true }
    }
}
